/** Feedback háptico (vibración) para acciones críticas en móvil. */

/** Vibra el dispositivo si está soportado. No falla si no hay API. */
export function hapticFeedback(pattern: number | number[] = 50): void {
  if (typeof navigator === 'undefined' || !('vibrate' in navigator)) return;
  try {
    navigator.vibrate(pattern);
  } catch {
    // Silencioso: la vibración es opcional.
  }
}

/** Vibración corta para acciones de confirmación (aprobar, crear). */
export function hapticSuccess(): void {
  hapticFeedback([30, 30, 30]);
}

/** Vibración larga para acciones destructivas (rechazar, borrar). */
export function hapticWarning(): void {
  hapticFeedback([50, 30, 50, 30, 50]);
}

/** Vibración de error (corta y brusca). */
export function hapticError(): void {
  hapticFeedback(100);
}
